import RetoricBreadcrumbs from "../../../../designsystems/RetoricBreadcrumbs/RetoricBreadcrumbs";
import Locations from "../../../../extensions/Locations";
import React, {useEffect} from "react";
import {useAuth} from "../../../../extensions/Auth";
import './UserAdd.css';
import {Form, Input, notification} from "antd";
import RetoricCard from "../../../../designsystems/RetoricCard/RetoricCard";
import RetoricButton from "../../../../designsystems/RetoricButton/RetoricButton";
import {UserService} from "../../../../services/UserService";

export default function UserAdd() {
    const auth = useAuth();
    const [api, contextHolder] = notification.useNotification();
    const [form] = Form.useForm();

    const addUser = () => {
        form.validateFields().then((values) => {
            UserService.addUser(values).then((x) => {
                if ("error" in x) {
                    api.error({
                        message: `Błąd`,
                        description: x.error,
                        placement: 'top'
                    });
                    return;
                }

                api.info({
                    message: `Operator dodany`,
                    description: `Operator ${values.name} został dodany do systemu`,
                    placement: 'top'
                });
                form.resetFields();
            });
        });
    }

    useEffect(() => {
        if (!auth.authCase?.isAdmin) {
            auth.handleLogout();
            return;
        }

    }, [auth]);
    return (
        <div>
            <RetoricBreadcrumbs locations={Locations['admin/users/new']} isAdmin>Dodaj operatora</RetoricBreadcrumbs>
            <RetoricCard className={'flex flex-col w-full bg-offwhite mt-4'}>
                {contextHolder}
                <Form
                    form={form}
                    onFinish={addUser}
                    className="flex lg:flex-row flex-col lg:items-end items-stretch lg:gap-4"
                    layout={'vertical'}>
                    <Form.Item label={"Imię i nazwisko"} required name="name"
                               className="flex-1"
                               rules={[{required: true, message: 'Imię i nazwisko jest wymagane!'}]}>
                        <Input placeholder={'Jan Nowak...'} className="rounded-none" size="large" id={'catTitle'}/>
                    </Form.Item>
                    <Form.Item label={"Email"} required name="email"
                               className="flex-1"
                               rules={[{required: true, message: 'Email jest wymagany!'}]}>
                        <Input placeholder={'jan@domena.pl...'} className="rounded-none" size="large" id={'catTitle'}/>
                    </Form.Item>
                    <Form.Item>
                        <RetoricButton type={'primary'} htmlType={'submit'}>Dodaj operatora</RetoricButton>
                    </Form.Item>
                </Form>
            </RetoricCard>
        </div>
    )
}
